module.exports = __webpack_public_path__ + "img/home6.88d2a636.png";